<template>
  <div class="loaderWrapper" :class="{inline}">
    <div class="loader" :class="{inline}"/>
  </div>
</template>

<script>
export default {
  name: "SmallLoader",
  props: ['inline']
}
</script>

<style scoped lang="scss">


.loaderWrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  left: 0;
  top: 0;
  width: 100%;
  height: 25vh;
  background: var(--bgColor);
  z-index: 9;
}

.loaderWrapper.inline {
  height: auto;
  display: inline-block;
  vertical-align: middle;
  background: transparent;
}

.loader {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: conic-gradient(var(--highlightColor), 10%, transparent);
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
  animation: s3 1s infinite linear;
}

.loader.inline {
  -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 4px), #000 0);
  height: 18px;
  width: 18px;
}

@keyframes s3 {
  to {
    transform: rotate(1turn)
  }
}
</style>
